// extracted by mini-css-extract-plugin
export default {"state":"styles_state__MG0Bg","title":"styles_title__0x7aP","content":"styles_content__xZhaU","bottom":"styles_bottom__CQX14"};